<template>
  <section id="fiber" class="position-relative">
    <b-container>
      <h5 class="text-white">
        Imagine fiber
      </h5>
      <h2 class="fiber-main-headline">
        Small fibers can make a big difference
      </h2>
      <p class="text-white medium hidden-xs show-lg">
        We advance the capabilities of what fiber-based materials can do. We develop and innovate applications, <br>solutions and end user experiences, striving to rethink the role fiber has in our society.
      </p>
      <div class="btn-container">
        <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.fiber, 3)"
	        	class="btn btn-black-trans"
		        target="_blank">
          Learn more
        </a>
      </div>
      <b-row>
        <b-col cols="12" xl="10" class="mx-auto col-xxl-8">
          <div class="word" style="height: 40vh;">
            <scroll-view :offset="100">
              <template slot-scope="visibility">
                <c-word class="text-white"
                        key="word1"
                        :visible="visibility.word1"
                        :delay="0"
                        :word="'Purify'"
                        :posTop="'20%'"
                        :posLeft="'0'"
                        :posRight="'auto'"
                        :posBottom="'auto'"
                        :fontWeight="'black'"
                        :fontSize="'biggest'"/>
              </template>
            </scroll-view>

            <scroll-view :offset="100">
              <template slot-scope="visibility">
                <c-word class="text-white"
                        key="word2"
                        :visible="visibility.word2"
                        :delay="500"
                        :word="'Perform better'"
                        :posTop="'15%'"
                        :posLeft="'auto'"
                        :posRight="'10%'"
                        :posBottom="'auto'"
                        :fontWeight="'semi-bold'"
                        :fontSize="'bigger'"/>
              </template>
            </scroll-view>

            <scroll-view :offset="100">
              <template slot-scope="visibility">
                <c-word class="text-white"
                        key="word3"
                        :visible="visibility.word3"
                        :delay="1500"
                        :word="'Diagnose'"
                        :posTop="'55%'"
                        :posLeft="'43%'"
                        :posRight="'auto'"
                        :posBottom="'auto'"
                        :fontWeight="'semi-bold'"
                        :fontSize="'medium'"/>
              </template>
            </scroll-view>

            <scroll-view :offset="100">
              <template slot-scope="visibility">
                <c-word class="text-white"
                        key="word4"
                        :visible="visibility.word4"
                        :delay="1000"
                        :word="'Solutions for the future'"
                        :posTop="'80%'"
                        :posLeft="'10%'"
                        :posRight="'auto'"
                        :posBottom="'auto'"
                        :fontWeight="'bold'"
                        :fontSize="'big'"/>
              </template>
            </scroll-view>

            <scroll-view :offset="100">
              <template slot-scope="visibility">
                <c-word class="text-white"
                        key="word5"
                        :visible="visibility.word5"
                        :delay="2000"
                        :word="'Safer food'"
                        :posTop="'70%'"
                        :posLeft="'auto'"
                        :posRight="'0'"
                        :posBottom="'auto'"
                        :fontWeight="'black'"
                        :fontSize="'bigger'"/>
              </template>
            </scroll-view>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  import CWord from '../components/Word.vue';
  import full from '../assets/pdf/full-report.pdf';
  import fiber from '../assets/pdf/fiber.pdf';

  export default {
    name: 'Fiber',
    data() {
      return {
        pdfLinks: {
          'full': full,
          'fiber': fiber
        }
      }
    },
    components: {
      CWord
    }
  }
</script>



// WEBPACK FOOTER //
// src/sections/Fiber.vue